// extracted by mini-css-extract-plugin
export var SidebarBlock = "sidebar-block-module--SidebarBlock--381nj";
export var SidebarBlock__header = "sidebar-block-module--SidebarBlock__header--3xRoQ";
export var SidebarBlock__title = "sidebar-block-module--SidebarBlock__title--zsXVt";